import { estaContido, validarQtdeCaractere } from './auxiliares';
import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosSlug = () => {
  const criterios = [
    {
      texto: 'O slug deve conter entre 1 e 60 caracteres',
      otimizado: false,
    },
    {
      texto: 'Este campo não pode estar vazio',
      otimizado: false,
    },
    {
      texto: 'O slug deve conter a palavra-chave',
      otimizado: false,
    },
    {
      texto: 'O slug não deve conter caracteres especiais',
      otimizado: false,
    },
    {
      texto: 'O slug não deve conter espaços',
      otimizado: false,
    },
  ];

  function validacoes(index, slug, palavraChave) {
    switch (index) {
      case 0:
        return validarQtdeCaractere(slug, 1, 60);
      case 1:
        return slug !== null && slug !== undefined && slug.length > 0;
      case 2:
        return estaContido(slug, palavraChave);
      case 3:
        return !/[^a-zA-Z0-9-]/.test(slug);
      case 4:
        return !slug.includes(' ');
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
